<template>
  <div id="container" v-loading.fullscreen="loading">
    <div class="detail_main" v-if="list">
      <div class="searchResults">
        <div class="resultsBox full_layout">
          <span class="resultsSpan">{{ $t('colon.category') }}</span>
          <span class="resultsSpan">{{ list.FirstCategoryName }} > {{ list.SecondCategoryName }} > {{ list.ThirdCategoryName }}</span>
        </div>
      </div>
      <div class="cardDetailsBox full_layout">
        <div class="cardDetails" :class="(list.OrderType == 1 && ((list.ReleaseType == 1 && CountDown(list.LastOnTime) != '00:00' && list.QuantitySold > 0) || (list.QuantitySold <= 0))) || (list.OrderType != 1 && list.Status != 1)||(sellerInfo&&sellerInfo.IsInBlacklist) ? 'Release' : ''">
          <div v-if="list.ReleaseType == 1 && list.OrderType == 1 && CountDown(list.LastOnTime) != '00:00'" class="sold ReleaseType">{{$t('base.comingSoon')}}</div>
          <div v-if="(list.QuantitySold <= 0 && list.OrderType == 1)" class="sold QuantitySold">{{$t('base.soldOut')}}</div>
          <div v-if="list.OrderType != 1 && list.Status < 0" class="sold QuantitySold">{{$t('base.soldOut')}}</div>
          <div v-if="(sellerInfo&&sellerInfo.IsInBlacklist)" class="sold QuantitySold blocked">{{$t('base.addedBlockedList')}}</div>
          <card-swiper :list="imgList" />
          <div class="tosell" v-if="userInfo != null && userInfo.IsSeller" @click='gotoSell'>{{ $t('symbol.sell') }} <span>{{ $t('base.sellNow') }}</span></div>
        </div>
        <!-- detail auction-->
        <auction-detail :list='list' :otherList='otherList' v-if="list.Status == 1 && list.ByWay == 2 && !isFinish" @acution="auctionFinish" @updateDetail='updateDetail' @isus='ISUS' @ispremium="IsPremium" />
        <!-- detail buynow-->
        <buy-now :list='list' :otherList='otherList' v-if="list.Status == 1 && list.ByWay == 1" @isus='ISUS' @ispremium="IsPremium" />
        <!-- detail 结束 -->
        <finish-detail :list='list' :otherList='otherList' :ByWay='ByWay' type="0" v-if="list.Status != 1" @isus='ISUS' @ispremium="IsPremium" />
        <!--  -->
        <finish-detail :list='list' :otherList='otherList' :ByWay='ByWay' type="1" v-if="isFinish" @isus='ISUS' @ispremium="IsPremium" />
        <!-- seller info -->
        <div class="sellerInfoBox">
          <div class="seller_info" v-if="sellerInfo != ''">
            <div class="seller_info_title">{{ $t('base.sellerInfo') }}</div>
            <!-- <div class="seller_info_f">
              <router-link class="sellerInfo_a sellerInfo_title line_txt2" :to="{path:'/seller/detail/'+list.SellUserID}">
              <span class="StoreName">{{sellerInfo.StoreName}}</span>
            </router-link>
              <span class="SellFavorableCount">{{sellerInfo.BuyFavorableCount+sellerInfo.SellFavorableCount}}</span>
            </div> -->
            <!-- <span class="SellFavorableCount">{{sellerInfo.BuyFavorableCount}}</span> -->
            <router-link class="sellerInfo_title" :to="{ path: '/seller/detail/' + list.SellUserID }">
              <span class="sellerInfo_a StoreName line_txt1">{{ sellerInfo.StoreName }}</span>
              <span class="sellerInfo_a SellFavorableCount">{{ sellerInfo.BuyFavorableCount + sellerInfo.SellFavorableCount }}</span>
            </router-link>
            <div class="seller_info_title seller_info_title_last">{{ sellerInfo | setFeedback }} {{ $t('base.positive') }}</div>
            <div class="line line_tb"></div>
            <div class="sellerInfo_a sellerInfo_a_h" v-if="userInfo != null && list.SellUserID != userInfo.MappingUserId" @click="allContact(list.SellUserID)">{{ $t('base.contactSeller') }}</div>
            <!-- <router-link class="sellerInfo_a sellerInfo_a_h" :to="{path:'/terms/customer',query:{item:JSON.stringify(listInfo),seller:list.SellRealName,sellerid:list.SellUserID}}">Contact seller</router-link> -->
            <router-link class="sellerInfo_a sellerInfo_a_h" :to="{ path: '/seller/detail/' + list.SellUserID }">{{ $t('base.seeOtherItems') }}</router-link>
            <div class="attention" v-if="userInfo != null">
              <div class="seller_save" :class="sellerInfo.IsAttention ? 'on' : ''" @click='setAttention()'>
                {{ sellerInfo.IsAttention ? $t('base.saved') : $t('base.saveSeller') }}</div>
            </div>
            <router-link class="attention" :to="{ path: '/login' }" v-else>
              <div class="seller_save">{{ $t('base.saveSeller') }}</div>
            </router-link>
          </div>
        </div>
        <!--  -->
      </div>
      <!-- <div class="all_box full_layout">
        <div class="all_title">
          You May Also Like
          <router-link :to="{ name: '' }">See all</router-link>
        </div>
        <div class="all_box">
          <like-swiper :data1="recommend" />
        </div>
      </div> -->
      <!--  -->
      <!-- You May Also Like -->
      <like-swiper class="full_layout" />

      
      <div class="full_layout">
        <div class="bids_tabs">
          <div @click="BidsTabs(0)" :class="bidsTabs == 0 ? 'on' : ''">
            {{ $t('base.description') }}
          </div>
          <div @click="BidsTabs(1)" :class="bidsTabs == 1 ? 'on' : ''">
            {{ $t('base.shipping') }}
          </div>
          <div @click="BidsTabs(2)" v-if="list.OrderType != 1" :class="bidsTabs == 2 ? 'on' : ''">
            {{ $t('base.buyerPremium') }}
          </div>
          <div @click="BidsTabs(3)" v-if="userInfo!=null&&(list.OrderType != 1&&userInfo.MemberSource=='US')" :class="bidsTabs == 3 ? 'on' : ''">
            {{ $t('base.stateTax') }}
          </div>
        </div>
        <div class="dasapDetails" ref='USA'>
          <div class="spacing" v-if="bidsTabs == 0">
            <div class="attribute">
              <div class="Condition_span_box" v-for="(item, index) in Properties" :key="index">
                <div class="conditionSpan">{{categoryI18n(item.PropertyEnName)}}:</div>
                <div class="content_div">
                  <p>{{ item.PropertyValue }}</p>
                </div>
              </div>
            </div>
            <div class="dasapDetails_title" v-if='list.Detail != "null" && list.Detail != ""'>{{ $t('base.itemSpecifics') }}</div>
            <!-- <div class="condition" :class="list.Detail ? 'ifHide':''" v-if='list.Detail&&list.Detail!=""' v-html='list.Detail!=""?`<span class="weight" style="width: 90px;margin: 0 8px 0 0;">Notes:</span>`+list.Detail:""'> -->
            <div class="condition" :class="list.Detail != 'null' ? 'ifHide' : ''" v-if='list.Detail != "null" && list.Detail != ""' v-html='list.Detail != "" && list.Detail != "null" ? list.Detail : ""'>
            </div>
          </div>
          <div class="spacing" v-if="bidsTabs == 1">
            <!-- 邮费 -->
            <div v-for="(item, index) in list.DomesticCustom" :key="index" class="if_US" >
              <div class="dasapDetails_title" v-if="item.Status == 1">{{ index>0?$t('base.otherLocations'):$t('base.domesticShipping') }}:{{$t('base.shippingAndFree')}}</div>
              <div class="dasapDetails_title" v-if="item.Status == 2">{{ index>0?$t('base.otherLocations'):$t('base.domesticShipping') }}:{{$t('base.shippingAndPay')}}</div>
              <div class="dasapDetails_title" v-if="item.Status == 3">{{ index>0?$t('base.otherLocations'):$t('base.domesticShipping') }}: USD {{ item.USD_Price }}</div>
              <p class="dasapDetails_p" v-if="index>0">{{item.AreaName}}</p>
            </div>
            <!-- 称重 -->
            <div class="if_US weight_USA" v-if="userInfo != null&& (list.MemberSource != userInfo.MemberSource) && list.OrderType != 1">
              <div class="dasapDetails_title">{{$t('base.internationalShipping')}} <i>{{getAreaName(list.MemberSource)}} {{$t('base.to')}} {{getAreaName(userInfo.MemberSource)}}</i></div>
              <p class="dasapDetails_p text_gray">{{$t('alert.shippingFees')}} <br />
                {{$t('colon.paymentRateTable')}}</p>
              <div class="tab_dasap">
                <ul class="tab_dasap_ul">
                  <li class="tab_dasap_title">
                    <span>{{ $t('base.weight') }}</span>
                    <span>{{ $t('base.internationalShippingFee') }}</span>
                  </li>
                  <li v-for="(item, index) in WeightList" :key="index">
                    <span>{{ item.MinWeight > 0 ? item.MinWeight + 'kg' : item.MinWeight }} ~ {{ item.MaxWeight }}kg ({{ $t('base.included') }})</span>
                    <span>{{areaSymbol}} {{ item.WeightFeeUSD }}</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <!-- 服务费 -->
          <div class="spacing" v-if="bidsTabs == 2 && userInfo != null && list.OrderType != 1">
            <div class="if_US" style="border:none">
              <div class="dasapDetails_title"> {{ $t('title.premium') }}</div>
              <p class="dasapDetails_p">{{ $t('alert.serviceCharge',{ n: SPercent }) }}
              </p>
            </div>
          </div>
          <!-- 税 -->
          <div class="spacing" v-if="bidsTabs == 3 && userInfo != null && list.OrderType != 1&&userInfo.MemberSource=='US'">
            <div class="if_US " style="border:none">
              <div class="tab_tax">
                <ul class="tab_tax_ul" v-for="(tax, i) in TaxList" :key="i">
                  <li class="tab_tax_title">
                    <span>{{ $t('base.state') }}</span>
                    <span>{{ $t('base.tax') }}</span>
                  </li>
                  <li v-for="(item, j) in tax" :key="j">
                    <span>{{ item.StateName }}</span>
                    <span>{{ item.TaxPercent }}%</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="!loading && !list">
      <f-z-f :title="errorMsg" type="expired" />
      <like-swiper class="full_layout" />
    </div>
  </div>
  <!-- 没商品显示默认报错界面 -->
</template>
<script>
import * as signalR from '@aspnet/signalr'
import { countDown, getInfo, getTime, setUTC, priceExchange, GoYunXin, GetWorldUSD, getAreaDetail, isNumber, setMeta } from "@/api/public";
import FZF from "@/components/404.vue";
import LikeSwiper from "@/components/swiper/like";
import CardSwiper from "@/components/swiper/card";
import PlaceBid from "@/components/dialog/placebid";
import AuctionDetail from "@/components/detail/auction";
import BuyNow from "@/components/detail/buynow";
import FinishDetail from "@/components/detail/finish";

import qs from 'qs'

export default {
  name: "index",
  components: { LikeSwiper, CardSwiper, PlaceBid, AuctionDetail, FinishDetail, BuyNow, FZF },
  data() {
    return {
      areaSymbol: this.$store.state.areaSymbol,
      cid: '',
      oid: '', //商品id
      isFinish: false,
      loading: false,
      userInfo: null,
      list: '',
      TaxList: '', //税费列表
      WeightList: null, //重量列表
      otherList:{},
      listInfo: {},
      Properties: [],
      imgList: [],
      bidsTabs: 0,
      sellerInfo: '',
      isSeller: false,
      input: "",
      place_input: "",
      ByWay: 1,
      errorMsg: '',
      timer: "",
      SPercent: '',
      nowData: new Date().getTime(),
      signal: ''
    };
  },
  filters: {
    //百分比
    /**
     * 计算并格式化好评率百分比
     * @param {Object} val - 包含买卖双方好评和差评数量的对象
     * @param {number} val.BuyFavorableCount - 买家好评数
     * @param {number} val.SellFavorableCount - 卖家好评数  
     * @param {number} val.BuyNegativeCount - 买家差评数
     * @param {number} val.SellNegativeCount - 卖家差评数
     * @returns {string} 格式化的好评率百分比,如"98.50%"
     */
    setFeedback(val) {
      var FavorableCount = (val.BuyFavorableCount + val.SellFavorableCount)
      var TotalCount = (val.BuyFavorableCount + val.SellFavorableCount + val.BuyNegativeCount + val.SellNegativeCount)
      let data = ((FavorableCount / TotalCount) * 100)
      if (TotalCount > 0) {
        if (data != 100) {
          data = data.toFixed(2)
        }
      } else {
        data = 100
      }
      return data + '%'
    },
    setTime(val) {
      return setUTC(val, -8, 'cn')
    },
    // setAreaName(val, obj) {
    //   if (obj.OrderType != 1) {
    //     var a=this.$t('base.nationalDefaultArea')
    //     if (val == a) {
    //       val = $t('base.defaultArea')
    //     }
    //   }
    //   return val
    // }
  },
  created() {
    GetWorldUSD()
    //console.log("this.$route",this.$route);
    if (this.$route.query && this.$route.query.oid) {
      this.oid = this.$route.query.oid; //从订单进入商品详情，传入订单ID
    }
    this.cid = this.$route.params.id
    this.userInfo = getInfo()
    //console.log("created")
  },
  beforeRouteUpdate(to, from, next) {
    this.cid = to.params.id;
    this.userInfo = getInfo();
    this.getDetail();
    this.cardTimer()
    //console.log("beforeRouteUpdate",this.cid)
    next()
  },
  mounted() {
    this.getDetail()
    this.cardTimer()
    this.$root.$on("SPercent", val => {
      this.SPercent = val || 0;
    })
    this.newSignalR(); //链接SOCKET
  },
  destroyed() {
    if (this.signal) {
      this.signal.stop();
    }
  },
  methods: {
    /**
     * 将卡片类别转换为对应的国际化文本
     * @param {string} obj - 需要转换的类别字符串
     * @returns {string} 转换后的国际化文本
     * @description 
     * 1. 移除字符串中的空格
     * 2. 移除字符串中的 '/' 符号
     * 3. 通过 i18n 获取对应的翻译文本
     * 4. 如果没有找到对应翻译，返回原始文本
     */
    categoryI18n(obj) {
      var value = obj.replace(/\s*/g, "")
      if (value.indexOf('/') > 0) {
        value = value.replace('/', "")
      }
      var i18nValue=this.$t('categoryKey.' + value)
      if(i18nValue.indexOf('categoryKey.')>-1){
        i18nValue=obj
      }
      return i18nValue
      //console.log(value,'value')
    },
    newSignalR() {
      let that = this;
      let group = that.cid; //connectionToken;
      let url = process.env.VUE_APP_CMS_SOCKET + "/hubs?cId=" + group;
      //console.log('VUE_APP_CMS_SOCKET', url)
      that.signal = new signalR.HubConnectionBuilder().withUrl(url, {}).configureLogging(signalR.LogLevel.Information).build() //打印日志

      that.signal.start().then(() => {
        that.signal.invoke("connect", group);
        console.log('连接成功');
      }).catch((data) => {
        console.log('连接失败', data);
        that.signal.stop()
        //that.newSignalR()
      })
      that.signal.on('addChatMessage', that.receiveData);
    },
    /**
     * 接收并处理实时价格更新数据
     * @param {string} msg - WebSocket接收到的消息字符串
     * @description 处理商品价格实时更新:
     * 1. 解析接收到的数据
     * 2. 验证商品ID是否匹配
     * 3. 比较新旧价格和竞拍次数
     * 4. 当价格和竞拍次数发生变化时更新商品详情
     */
    receiveData(msg) {
      let that = this;
      let data = eval('(' + msg + ')');
       //console.log(data,priceExchange(data.List[0].Price, 'USD'),'data11')
      if (data && data.CommodityID == that.cid) {
        var oldPrice = isNumber(that.list.Price)
        var newPrice = priceExchange(data.List[0].Price, 'USD')
        var oldAuctionCount = that.list.AuctionCount
        //console.log(data.PriceCount,oldAuctionCount,newPrice,oldPrice,'receiveData')
        //if ((data.PriceCount != oldAuctionCount) && (newPrice != oldPrice)) {
          const setDetail = function() {
            if (data.List.length > 0) {
              that.list.Price = data.List[0].Price
              that.list.USD_Price=newPrice
              that.list.AuctionCount = data.PriceCount
              //console.log(that.list,'that.list')
               let AuctionsList = []

              const CensoredRealName = function(val) {
                let name = val.RealName
                  // if (name.length > 1) {
                  //   let name1 = val.substr(0, 1)
                  //   let name2 = val.substr(name.length - 1, 1)
                  //   name = name1 + '***' + name2
                  // }
                  
                if (val.AuctionUserID == that.userInfo.MappingUserId) {
                  name = that.userInfo.NickName
                }
                return name
              }
              data.List.map(item => {
                  let actionList = {
                    BuyFavorableCount: item.Favs,
                    CommodityID: data.CommodityID,
                    CreateDate: item.ActionTime,
                    CreateUser: item.AuctionUserID,
                    CreateUserName: CensoredRealName(item),
                    ID: 0,
                    IsAuto: item.IsAuto ? true : false,
                    MemberSource: item.MemberSource,
                    Price: item.Price,
                    Status: 0,
                    USD_Price: priceExchange(item.Price, 'USD')
                  }
                  AuctionsList.push(actionList)
                })
              //console.log(AuctionsList,that.list,'AuctionsList')

                that.list.Auctions=AuctionsList
                //console.log(AuctionsList,that.list.Auctions)
            }

            //console.log(that.list)
          }
          //測試只改list 不重新調商品詳情的接口
          setDetail()
          //console.log(data,'data')
          // that.getDetail();
        //}
        //that.list.AuctionCount
        //that.cardTimer();
      }
    },
    /**
     * 根据地区编码获取地区名称
     * @param {string|number} val - 地区编码
     * @param {string} name - 名称参数(未使用)
     * @returns {string} 返回对应的地区名称
     */
    getAreaName(val, name) {
      let areaName = getAreaDetail(val)
      let cardLang = this.$cookie.get('CardLang')
      return areaName[0].areaName
      //console.log(a,'a1111')
    },
    /**
     * 设置区域名称
     * @param {string} val - 区域名称值
     * @param {Object} obj - 包含订单类型的对象
     * @param {number} obj.OrderType - 订单类型
     * @returns {string} 处理后的区域名称
     * @description 根据订单类型处理区域名称,当订单类型不为1时,使用默认区域名称
     */
    setAreaName(val, obj) {
      if (obj.OrderType != 1) {
        var val = this.$t('base.nationalDefaultArea')
        if (val == this.$t('base.nationalDefaultArea')) {
          val = this.$t('base.defaultArea')
        }
      }
      return val
    },
    // 获取重量与邮费列表
    /**
     * 获取重量列表数据
     * 根据用户信息和区域设置获取对应的重量列表
     * @description 发送GET请求获取重量列表，根据用户所在区域(MemberSource)和代理ID进行筛选
     * 如果用户区域为澳门(MO)，则设置区域符号为MOP
     * 获取成功后更新WeightList数据
     */
    GetWeightList() {
      let that = this
      let data = { pageIndex: 1, pageSize: 99 }
      if (that.userInfo != null) {
        data = Object.assign({}, data, { region: that.userInfo.MemberSource, agencyId: that.list.MemberSource })
        if (that.userInfo.MemberSource == "MO") {
         // that.areaSymbol = "MOP"
        }
      }
      this.$get(this.$interface.GetWeightList, data).then(res => {
        if (res.result != 0) {
          that.WeightList = res.Data
        }
      })
    },
    // 获取税费列表
    /**
     * 获取税务列表数据
     * 通过用户信息请求税务列表,并对返回数据进行分组处理
     * @description 调用接口获取税务列表数据,将列表按每4条数据进行分组
     * @returns {void} 将处理后的数据存储在组件的 TaxList 数据中
     */
    GetTaxList() {
      let that = this
      let data = { 'memberid': that.userInfo.MappingUserId, 'token': that.userInfo.ChineseToken, 'operator_id': that.userInfo.MappingUserId, }
      that.$get(that.$interface.GetTaxList, data).then(res => {
        if (res.result != 0) {
          var result = res.data
          var resLength = result.length
          var reslimt = Math.ceil(resLength / 4)
          var newArr = [];
          for (var i = 0; i <= resLength; i++) {
            var data = result
            newArr.push(result.slice(i, i + reslimt))
            i += reslimt
          }
          that.TaxList = newArr
        }
      })
    },
    cardTimer() {
      this.timer = setInterval(() => {
        this.nowData = this.nowData + 1000;
      }, 1000);
    },
    // 获取倒计时
    CountDown(itemEnd, val) {
      itemEnd = itemEnd.toString().replace(/-/g, "/")
      let i = setUTC(itemEnd, -8, 'cn')
      let newval = setUTC(this.nowData, -8)
      if (val == 0) {
        if (countDown(i, newval) == "00:00") {
          this.$emit('acution')
        }
      }
      //console.log(i, newval, itemEnd)
      //console.log(itemEnd)
      return countDown(i, newval)
    },
    // 跳去卖家端
    /**
     * 处理跳转到卖家页面的逻辑
     * 检查用户是否登录及是否为卖家身份
     * 如果是卖家则跳转到新建商品页面
     * 如果不是卖家或未登录则显示错误提示
     * @returns {void}
     */
    gotoSell() {
      let that = this
      if (this.userInfo != null) {
        let isSell = this.userInfo.IsSeller
        if (isSell) {
          const url = process.env.VUE_APP_SELL_URL + '/#/commodity/New?id=' + this.cid + '&clone=new'
          window.open(url)

        } else {
          this.$message({
            type: 'error',
            duration: 1000,
            message: that.$enumInfo.error['NOSell']
          });
        }
      } else {
        this.$message({
          type: 'error',
          duration: 1000,
          message: that.$enumInfo.error['NOSell']
        });
      }
      //console.log(process.env.VUE_APP_SELL_URL)
    },
    //
    allContact(val) {
      if (this.userInfo) {
        GoYunXin(this.userInfo, val,this.cid,1000)
      } else {
        this.$router.push({
          name: 'Login'
        })
      }
    },
    // 获取商品详情
    getDetail() {
      let that = this;
      that.loading = true
      let data = { 'memberid': '', 'CommodityID': this.cid, 'lag': 'en' }
      if (that.userInfo != null) {
        that.GetTaxList()
        data = { 'memberid': that.userInfo.MappingUserId, 'token': that.userInfo.ChineseToken, 'operator_id': that.userInfo.MappingUserId, 'CommodityID': this.cid,buyerSource:that.userInfo.MemberSource, 'lag': 'en' }
      }
      if (this.oid) {
        data['OrderDetailId'] = this.oid;
      }
      that.$get(that.$interface.DetailCommodity, data).then(res => {
        if (res.result != 0) {
          let data = res.data
          //console.log("data", data)
          that.ByWay = data.ByWay
          //console.log(data.images.split(','))

          document.title = data.Title;
          setMeta('apple-itunes-app', ', app-argument=cardOverseasApp://CommodityID:' + data.ID, 1)
          data.HighestPrice = priceExchange(data.HighestPrice, 'USD')
          data.Detail = decodeURIComponent(data.Detail)
          that.listInfo.TitImg = data.TitImg
          that.listInfo.Title = data.Title
          that.listInfo.USD_Price = data.USD_Price
          that.listInfo.USD_PostageMoney = data.PostageMoney
          that.imgList = data.images != '' ? data.images.split(',') : [data.TitImg]
          that.Properties = data.Properties;
          if (that.userInfo != null) {
            data.BusinessType = 0
            if (that.userInfo.MemberSource != data.MemberSource) {
              data.BusinessType = 2
            }
          }
          that.list = data;
          that.getNationIcons()
          that.GetWeightList()
          if (that.userInfo != null) {
            that.getSeller()
          }
          that.GetStoresList()
          //that.getAttention()
        } else {
          that.list = null;
          that.errorMsg = res.msg
        }
        that.loading = false
      })
    },
    getNationIcons() {
      let that = this
      that.otherList.address=''
      that.$get(this.$interface.GetAllNationIcons, '').then(res => {
        if (res.Result != 0) {
          var result=res.Data
          const resultMap=function(result){
              if(that.list.MemberSource=='CN'){
                that.otherList.address = 'China'
              }else{
                result.map(item=>{
                  if(item.Code==that.list.MemberSource){
                    that.otherList.address=item.EnName
                  }
                })
              }
          }
          if(that.userInfo){
            if(that.userInfo.MemberSource!=that.list.MemberSource){
              resultMap(result)
            }else{
              that.otherList.address=that.list.Address
            }
          }else{
              resultMap(result)
          }
        }
      })
    },
    // 关注商家
    /**
     * 设置关注状态
     * 向服务器发送关注/取消关注请求
     * @requires userInfo 用户信息对象,包含 MappingUserId 和 ChineseToken
     * @requires list.SellUserID 卖家用户ID
     * @fires GetStoresList 成功设置关注后刷新店铺列表
     */
    setAttention() {
      let that = this;
      if (that.userInfo != null) {
        let data = { 'selluserid': that.list.SellUserID, 'memberid': that.userInfo.MappingUserId, 'token': that.userInfo.ChineseToken, 'operator_id': that.userInfo.MappingUserId }
        this.$post(that.$interface.SetAttention, qs.stringify(data)).then(res => {
          if (res.result != 0) {
            // that.sellerInfo.IsAttention=!that.sellerInfo.IsAttention
            that.GetStoresList()
          }
        })
      }
    },
    BidsTabs(val) {
      this.bidsTabs = val
      //console.log("BidsTabs",val)
    },
    //保存游览记录
    /**
     * 获取卖家信息并保存浏览历史
     * @description 发送POST请求保存用户的商品浏览记录
     * @param {void} 
     * @returns {Promise} 返回请求的Promise对象
     * @access private
     * @memberof carddetails
     */
    getSeller() {
      let that = this
      let data = { 'MemberId': that.userInfo.MappingUserId, 'token': that.userInfo.ChineseToken, 'operator_id': that.userInfo.MappingUserId, CommodityId: this.$route.params.id }
      this.$post(this.$interface.SaveTourHistory, qs.stringify(data)).then(res => {

      }).catch(error => {

      })
    },
    //获取商家信息
    /**
     * 获取商家店铺详细信息
     * @param {any} val - 参数值(未使用)
     * @description 根据商家ID获取店铺详情,如果用户已登录则同时检查黑名单状态
     * @access private
     * @fires getInBlacklist - 当获取店铺信息成功且用户已登录时触发
     */
    GetStoresList(val) {
      let that = this
      let data = { 'Id': that.list.SellUserID, 'MemberId': '' }
      if (that.userInfo != null) {
        data.MemberId = that.userInfo.MappingUserId
      }
      this.$get(this.$interface.GetStoreDetail, data).then(res => {
        if (res.result != 0) {
          //console.log(that.sellerInfo)
          that.sellerInfo = res.data
          if (that.userInfo != null) {
            that.getInBlacklist()
          }
        }
      })
    },
    getInBlacklist() {
      let that = this
      let data = { 'SellUserID': that.list.SellUserID, 'memberid': that.userInfo.MappingUserId, operator_id: that.userInfo.MappingUserId, token: that.userInfo.ChineseToken }
      that.$get(this.$interface.AttentionDetail, data).then(res => {
        if (res.result) {
          that.sellerInfo.IsInBlacklist = res.data.IsInBlacklist
        }
      })
    },
    updateDetail(val) {
      let that=this
      if(val){
        that.list = val
      }else{
        this.getDetail();
      }
    },
    auctionFinish() {
      this.isFinish = true;
    },
    ISUS() {
      this.bidsTabs = 1;
      window.scrollTo(0, 2000)
    },
    IsPremium(val) {
      this.bidsTabs = val;
      window.scrollTo(0, 2000)
    }
  },
};

</script>
<style scoped>
@import "../../../static/css/carddetails.css";

/* .descriptionBox{
  margin-bottom: 40px;
} */
.tosell span {
  color: #5f6dae;
  cursor: pointer;
}

.tosell span:hover {
  text-decoration: underline;
}

.cardDetails.Release {
  position: relative;
}

.cardDetails.Release .sold {
  position: absolute;
  width: 100%;
  height: 32px;
  line-height: 32px;
  text-align: center;
  color: #fff;
  font-size: 20px;
  background-repeat: no-repeat;
  background-position: center;
  z-index: 9;
  background-size: auto 100%;
  right: 0;
  top: 295px;
  border-radius: 0 0 4px 4px;
}
.cardDetails.Release .blocked{
  font-size: 17px;
}

.cardDetails.Release .ReleaseType {
  /*background-image: url(../../../static/images/comingsoon.svg);*/
  background-color: #5F6DAE;
}

.cardDetails.Release .QuantitySold {
  /*background-image: url(../../../static/images/soldout.svg);*/
  background-color: #a0a0a0;
}

</style>



// WEBPACK FOOTER //
// src/pages/carddetails/index.vue